import api from "../../services/api";
import {
  CREATE_CENTRE_BOOKING_FAILURE,
  CREATE_CENTRE_BOOKING_REQUEST,
  CREATE_CENTRE_BOOKING_SUCCESS,
  GET_CENTRE_BOOKINGS_FAILURE,
  GET_CENTRE_BOOKINGS_REQUEST,
  GET_CENTRE_BOOKINGS_SUCCESS,
  RESET_CENTRE_BOOKING_STATE,
} from "./ActionType";

const createCentreBookingRequest = () => ({
  type: CREATE_CENTRE_BOOKING_REQUEST,
});

const createCentreBookingSuccess = (booking) => ({
  type: CREATE_CENTRE_BOOKING_SUCCESS,
  payload: booking,
});

const createCentreBookingFailure = (error) => ({
  type: CREATE_CENTRE_BOOKING_FAILURE,
  payload: error,
});

const getCentreBookingsRequest = () => ({
  type: GET_CENTRE_BOOKINGS_REQUEST,
});

const getCentreBookingsSuccess = (bookings) => ({
  type: GET_CENTRE_BOOKINGS_SUCCESS,
  payload: bookings,
});

const getCentreBookingsFailure = (error) => ({
  type: GET_CENTRE_BOOKINGS_FAILURE,
  payload: error,
});

export const resetCentreBookingState = () => ({
  type: RESET_CENTRE_BOOKING_STATE,
});

export const createCentreBooking =
  ({ booking, onSuccess, onError }) =>
  async (dispatch) => {
    dispatch(createCentreBookingRequest());
    try {
      const response = await api.post("/bookings/centre-bookings", booking, {
        withCredentials: true,
      });
      dispatch(createCentreBookingSuccess(response.data));
      if (onSuccess) {
        onSuccess(response.data);
      }
    } catch (error) {
      dispatch(createCentreBookingFailure(error));
      if (onError) {
        onError(error);
      }
    }
  };

export const getCentreBookings = (page = 0) => async (dispatch) => {
  dispatch(getCentreBookingsRequest());
  try {
    const response = await api.get(`/bookings/centre-bookings?page=${page}`, {
      withCredentials: true,
    });
    dispatch(getCentreBookingsSuccess(response.data));
  } catch (error) {
    dispatch(getCentreBookingsFailure(error));
  }
};


